import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import EmbedReadiness from "@/pages/EmbedReadiness";

export const Route = createFileRoute("/embed/readiness")({
  head: () => seoHead("/embed/readiness"),
  component: EmbedReadiness,
});
